import { createAction } from '@reduxjs/toolkit';

export const fetchAgencyFromUser = createAction('[User] fetchAgencyFromUser');
export const fetchCurrentUserSuccess = createAction('[User] fetchCurrentUserSuccess');
export const setUserFacilities = createAction('[User] setUserFacilities');
export const updatePreferredFacility = createAction('[User] updatePreferredFacility');
export const selectPatientExternalId = createAction('[User] selectPatientExternalId');
export const fetchAccessTokenSuccessfully = createAction('[User] fetchAccessTokenSuccessfully');
export const selectPreferredFacility = createAction('[User] selectPreferredFacility');
